import './Button.scss';

const Button = ({ children, onClick, variant = 'primary', disabled, type = 'button', style = {} }) => {
    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled}
            className={`btn btn--${variant}`}
            style={style}
        >
            {children}
        </button>
    );
};

export default Button;
